import * as React from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalTitle
} from '../../common/modal';
import { PanelType, Project } from '@nexxt/common/types';
import NotifyHOC from '../../../HOC/Notifications';
import { LinkGenerator } from '../../common/LinkGenerator';
import config from '../../../config';

interface LinkGeneratorModalProps {
    onClose: () => void;
    user: any;
    project: Project;
    forceTestMode?: boolean;
    hidePanel?: boolean;
    toastNotification: any;
    isWizard: boolean;
    previewLink?: string;
}
interface LinkGeneratorModalState {
    chatbotURL: string;
}
class LinkGeneratorModal extends React.Component<
    LinkGeneratorModalProps,
    LinkGeneratorModalState
> {
    constructor(props) {
        super(props);
        /**
         * Temporary add the list in localstorage
         */
        this.state = {
            chatbotURL: this.props.previewLink
                ? this.props.previewLink
                : `${config.host.bot}/p/${this.props.project.codeName}`
        };
    }
    render() {
        const { chatbotURL } = this.state;
        const { onClose, toastNotification, project, isWizard } = this.props;
        const incaPanel = project?.panelSettings?.panelType === PanelType.INCA;
        const forceTestMode = isWizard || incaPanel;
        const hidePanel = isWizard || incaPanel;
        return (
            <Modal isOpen={true}>
                <ModalHeader onClose={() => onClose()}>
                    <ModalTitle>Share links</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <LinkGenerator
                        toastNotification={toastNotification}
                        chatbotURL={chatbotURL}
                        currentProject={project}
                        forceTestMode={forceTestMode}
                        hidePanel={hidePanel}
                    />
                </ModalBody>
                <ModalFooter>
                    <button
                        className="btn btn--sm btn--transparent m-r-10"
                        onClick={() => onClose()}
                    >
                        Cancel
                    </button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default NotifyHOC(LinkGeneratorModal);
